// extracted by mini-css-extract-plugin
export default {"page":"app_page__+baSO","container":"app_container__rFSLb"};